'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/distinctUntilChanged';
const angular = require('angular');
const {lowercase} = angular;

var booleanTemplate = require('./boolean.html');
var numberTemplate = require('./number.html');
var stringTemplate = require('./string.html');
var stringListTemplate = require('./string-list.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  FormOptionDirective];

module.exports.controller = [
  '$scope',
  '$translate',
  'FormUtils',
  FormOptionController];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

var labelMaps = {};

function CacheTemplates(
  $templateCache,
) {
  $templateCache.put('forms/options/boolean.html', booleanTemplate);
  $templateCache.put('forms/options/number.html', numberTemplate);
  $templateCache.put('forms/options/string.html', stringTemplate);
  $templateCache.put('forms/options/string-list.html', stringListTemplate);
}

function FormOptionDirective(TransformerDirectiveFactory) {
  var transformConfig = {
    controllerAs: 'formOption',
    bindToController: true,
    modes: [
      {name: 'boolean', templateUrl: 'forms/options/boolean.html', defaultMode: true},
      {name: 'number', templateUrl: 'forms/options/number.html'},
      {name: 'string', templateUrl: 'forms/options/string.html'},
      {name: 'string-list', templateUrl: 'forms/options/string-list.html'}
    ]
  };

  return {
    restrict: 'E',
    template: '',
    scope: {
      currentMode: '=?',
      model: '=',
      field: '=',
      option: '='
    },
    controllerAs: 'formOption',
    bindToController: true,
    compile: TransformerDirectiveFactory(transformConfig),
    controller: 'FormOptionController'
  };
}

function FormOptionController(
  $scope,
  $translate,
  FormUtils,
) {
  var vm = this;

  //TODO: listen for language changes
  var typeObservable = $scope
    .$toObservable(function () {
      return vm.field && vm.field.type;
    })
    .map(function (data) {
      return data.newValue;
    })
    .distinctUntilChanged();

  var optionObservable = $scope
    .$toObservable(function () {
      return vm.option;
    })
    .map(function (data) {
      return data.newValue;
    })
    .distinctUntilChanged();

  Observable.combineLatest(
    typeObservable, optionObservable, getCode)
    .switchMap(observableTranslate)
    .subscribe(function (label) {
      vm.label = label;
      vm.constraints = vm.field ? FormUtils.generateOptionsConstraints(vm.field.type) : null;
      var mode = getMode(vm);
      if (mode)
        vm.currentMode = mode;
    });

  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function getCode(type, optionName) {
    if (optionName === 'required') return 'forms.default.options.required.label';

    return lowercase([
      'forms',
      type,
      'options',
      optionName,
      'label'
    ].join('.'));
  }

  function translateCode(code) {
    var deferred = Promise.defer();
    var currentLang = $translate.proposedLanguage();
    if (!currentLang) {
      currentLang = $translate.use();
    }

    if (!currentLang) {
      deferred.reject('Failed to get current language from angular translate!');
    } else {
      var msgMap = labelMaps[currentLang] || {};
      var msg = msgMap[code];

      if (msg) {
        deferred.resolve(msgMap[currentLang]);
      } else {
        $translate(code).then(
          function (newMsg) {
            msgMap[code] = newMsg;
            deferred.resolve(newMsg);
          },
          deferred.reject.bind(deferred)
        )
      }
    }

    return deferred.promise;
  }

  function observableTranslate(code) {
    return Observable.fromPromise(translateCode(code));
  }

  function getMode(vm) {
    var type = vm.constraints && vm.constraints[vm.option] && vm.constraints[vm.option].type;
    if (type != 'string') {
      return type;
    } else {
      return vm.constraints[vm.option].inList ? 'string-list' : 'string';
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/forms/directives/options/FormOptionDirective.js